import { render, staticRenderFns } from "./list-reviews.vue?vue&type=template&id=2a168956"
import script from "./list-reviews.vue?vue&type=script&lang=js"
export * from "./list-reviews.vue?vue&type=script&lang=js"
import style0 from "./list-reviews.vue?vue&type=style&index=0&id=2a168956&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports